declare module "@mui/material/styles/createPalette" {
    interface Palette {
        primary: PaletteColor;
        secondary: PaletteColor;
        border: SimplePaletteColorOptions;
        surface: PaletteColor;
        onPrimary: SimplePaletteColorOptions;
        posIcon: SimplePaletteColorOptions;
        textGrey: SimplePaletteColorOptions;
        smartSchedulerBackground: SimplePaletteColorOptions;
        alertBackground: SimplePaletteColorOptions;
        neutral: PaletteColor;
        purple: PaletteColor;
        blue: PaletteColor;
    }
    interface PaletteOptions {
        primary?: PaletteColorOptions;
        secondary?: PaletteColorOptions;
        border: SimplePaletteColorOptions;
        surface: PaletteColorOptions;
        onPrimary: SimplePaletteColorOptions;
        posIcon: SimplePaletteColorOptions;
        textGrey: SimplePaletteColorOptions;
        smartSchedulerBackground: SimplePaletteColorOptions;
        alertBackground: SimplePaletteColorOptions;
        neutral: PaletteColorOptions;
        purple: PaletteColorOptions;
        blue: PaletteColorOptions;
    }
}

export const colors = {
    primary: {
        "50": "#ebedff",
        "100": "#c2c8fe",
        "200": "#a4aefe",
        "300": "#7a89fe",
        "400": "#6172fd",
        "500": "#394dff",
        "600": "#3448e6",
        "700": "#2838b4",
        "800": "#1f2b8b",
        "900": "#18216a",
    },
    success: {
        "50": "#eaf8f6",
        "100": "#bde9e4",
        "200": "#9dded7",
        "300": "#70cfc4",
        "400": "#54c5b9",
        "500": "#29b7a7",
        "600": "#25a798",
        "700": "#1d8277",
        "800": "#17655c",
        "900": "#114d46",
    },
    warning: {
        "50": "#fdf0e6",
        "100": "#f9d2b1",
        "200": "#f7bc8b",
        "300": "#f39d56",
        "400": "#f18a35",
        "500": "#ed6d03",
        "600": "#d86303",
        "700": "#a84d02",
        "800": "#823c02",
        "900": "#642e01",
    },
    error: {
        "50": "#feeceb",
        "100": "#fcc5c1",
        "200": "#faa9a3",
        "300": "#f88178",
        "400": "#f6695e",
        "500": "#f44336",
        "600": "#de3d31",
        "700": "#ad3026",
        "800": "#86251e",
        "900": "#661c17",
    },
    surface: {
        "0": "#ffffff",
        "50": "#fdfdff",
        "100": "#f9f9ff",
        "200": "#f6f7ff",
        "300": "#f2f3ff",
        "400": "#eff1ff",
        "500": "#ebedff",
        "600": "#d6d8e8",
        "700": "#a7a8b5",
        "800": "#81828c",
        "900": "#63646b",
    },
    grey: {
        "50": "#e9e9eb",
        "100": "#babcc0",
        "200": "#999ca2",
        "300": "#6a6e77",
        "400": "#4d525d",
        "500": "#212734",
        "600": "#1e232f",
        "700": "#171c25",
        "800": "#12151d",
        "900": "#0e1016",
    },
    neutral: {
        "50": "#f2f3f6",
        "100": "#d6d9e2",
        "200": "#c2c7d4",
        "300": "#a6adc1",
        "400": "#959db5",
        "500": "#7a85a2",
        "600": "#6f7993",
        "700": "#575e73",
        "800": "#434959",
        "900": "#333844",
    },
    purple: {
        "25": "#faf6ff",
        "50": "#f3ebfe",
        "100": "#dbc1fc",
        "200": "#c9a3fa",
        "300": "#b178f8",
        "400": "#a15ef6",
        "500": "#8a36f4",
        "600": "#7e31de",
        "700": "#6226ad",
        "800": "#4c1e86",
        "900": "#3a1766",
    },
    blue: {
        "50": "#e9f5fe",
        "100": "#badefb",
        "200": "#99cff9",
        "300": "#6ab9f7",
        "400": "#4dabf5",
        "500": "#2196f3",
        "600": "#1e89dd",
        "700": "#176bad",
        "800": "#125386",
        "900": "#0e3f66",
    },
};

export const customPalette = {
    primary: {
        ...colors.primary,
        main: colors.primary["500"],
    },
    secondary: {
        ...colors.primary,
        main: colors.primary["500"],
    },
    error: {
        ...colors.error,
        main: colors.error["500"],
    },
    warning: {
        ...colors.warning,
        main: colors.warning["500"],
    },
    border: {
        main: "#DFEEF9",
    },
    surface: {
        ...colors.surface,
        main: colors.surface["0"],
    },
    onPrimary: {
        main: colors.surface["0"],
    },
    posIcon: {
        main: "#ED784C",
    },
    textGrey: {
        main: colors.neutral["500"],
    },
    smartSchedulerBackground: {
        main: "#F4F2FF",
    },
    other: {
        lightGrey: "#EEEEEE",
        darkBlue: "#000423",
    },
    alertBackground: {
        main: colors.surface["500"],
    },
    neutral: {
        ...colors.neutral,
        main: colors.neutral["500"],
    },
    purple: {
        ...colors.purple,
        main: colors.purple["500"],
    },
    blue: {
        ...colors.blue,
        main: colors.blue["500"],
    },
};
